import type { ApprovalDto } from '../services/MendsVisionService';
import { notCreatedText } from './approvalLabels';

/**
 * O que um POST /approvals realmente produziu. O backend devolve id 0 quando nada entrou na fila
 * (status `not_applicable`: sombra, LLM fora, contexto ilegível…) ou quando uma rotina executou na hora
 * (status `approved` + executed). Só `queued` pode dizer "enviado à fila" ou navegar até ela.
 */
export type CreateApprovalOutcome =
  | { kind: 'queued'; approval: ApprovalDto }
  | { kind: 'executed'; message: string }
  | { kind: 'not_created'; message: string };

export {
  RETRY_MESSAGE,
  SHADOW_MESSAGE,
  QUESTION_OPEN_MESSAGE,
  GENERIC_NOT_CREATED_MESSAGE,
} from './approvalLabels';

/** true quando o POST não criou nada que o vendedor possa abrir na fila. */
export function wasNotCreated(created: Pick<ApprovalDto, 'id' | 'status'> | null | undefined): boolean {
  return !created || !created.id || created.status === 'not_applicable';
}

/** Mensagem pt-BR para "nada foi criado", a partir do código estável do motivo (tabela em approvalLabels). */
export function notCreatedMessage(created: Pick<ApprovalDto, 'statusReason'> | null | undefined): string {
  return notCreatedText(created?.statusReason);
}

export function describeCreateOutcome(created: ApprovalDto | null | undefined): CreateApprovalOutcome {
  if (created && created.id > 0 && created.status !== 'not_applicable') {
    return { kind: 'queued', approval: created };
  }
  if (created && created.status === 'approved' && created.executed) {
    return { kind: 'executed', message: created.executionResult || 'Feito.' };
  }
  return { kind: 'not_created', message: notCreatedMessage(created) };
}
